/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../contexts/auth/authContext';
import { Can } from '../components';
import AccessForbidden from './auth/accessForbidden';
import { CanPermission } from '../components/Can/Can';

/**
 * Generate a PrivateRouter component to do Role Based Access Control
 * We need to pass the generator a set a rules and the react Router and Redirect instances.
 * @param rules A set of Permission Rules
 * @param Route Route from react-router-dom
 * @param Redirect Redirect from react-router-dom
 * @param shouldUseGroupAndPermission Groups And Permissions are still in Beta, someday we will remove the Roles and fully use GroupAndPermission => shouldUseGroupAndPermission will always be true
 */
const generatePrivateRouteComponent = (rules: any, Route: any, Redirect: any, shouldUseGroupAndPermission = false) => ({
    comp: Component,
    perm: permissions,
    ...props
}: any): React.ReactElement => {
    const authContext = useContext(AuthContext);
    const { logged, loading, userlogged, user } = authContext;

    /**
     * Checks whether user object's props are defined (not null) or not...
     */
    const [isUserLoaded, setIsUserLoaded] = useState<boolean>(false);
    function checkIfUserIsLoaded(): boolean {
        const loggedUser = { ...user } as { [key: string]: any; id: null; role: null; subStatus: null };
        return Object.keys(loggedUser).some((key) => loggedUser[key]);
    }

    useEffect(() => {
        if (logged) {
            userlogged();
        }
    }, []);

    useEffect(() => {
        if (checkIfUserIsLoaded()) setIsUserLoaded(true);
    }, [user]);

    const userPermissions = user?.permissions || [];

    return (
        <Route
            {...props}
            render={(componentProps: any): React.ReactElement =>
                !logged ? (
                    <Redirect to="/login" />
                ) : (
                    <div>
                        {!loading && user && isUserLoaded ? (
                            shouldUseGroupAndPermission ? (
                                <CanPermission
                                    userPermissions={userPermissions}
                                    permission={permissions}
                                    yes={(): React.ReactElement =>
                                        user.enabled ? (
                                            <Component {...componentProps} />
                                        ) : (
                                            <Redirect to="/postregister" />
                                        )
                                    }
                                    no={(): React.ReactElement => {
                                        return <AccessForbidden />;
                                    }}
                                />
                            ) : (
                                <Can
                                    rules={rules}
                                    role={user.role}
                                    perform={permissions}
                                    yes={(): React.ReactElement => <Component {...componentProps} />}
                                    no={(): React.ReactElement => <AccessForbidden />}
                                />
                            )
                        ) : (
                            <p />
                        )}
                    </div>
                )
            }
        />
    );
};

export default generatePrivateRouteComponent;
